<template>
    <div>
        <MessageSection>
            <div class="bodyCopy">The rental request is accepted. Please continue to payment to confirm the rental.</div>
        </MessageSection>
        <MessageSection>
            <router-link to="/payment" class="no-underline">
                <TooliabaButton>Continue to Payment</TooliabaButton>
            </router-link>
            <RequestTimer/>
        </MessageSection>
    </div>
</template>

<script>
import MessageSection from '@/components/inbox/messagesCard/shared/MessageSection.vue';
import TooliabaButton from '@/components/buttons/TooliabaButton.vue';
import RequestTimer from '@/components/inbox/messagesCard/shared/RequestTimer.vue';

export default {
    components: {
        MessageSection,
        TooliabaButton,
        RequestTimer
    }
};
</script>
